module.exports = __webpack_public_path__ + "img/gift-card-index.71896563.png";